// extracted by mini-css-extract-plugin
export default {"content":"payment-in-review_content__fC9BX","title":"payment-in-review_title__+MRXp","subtitle":"payment-in-review_subtitle__qRx07","note":"payment-in-review_note__d8VOu"};